<div class="full-width" *ngIf="permisoRol()">
    <div class="card card-default">
        <div class="card-body">
            <div class="row">
                <div class="col-10-flex">
                    <h4 class="text-primary">{{titulo}}</h4>
                </div>
                <div class="col-2 btn-align-right">
                    <button type="button" (click)="actualizarEstatus()" class="btn btn-primary boton float-right">Confirmar</button>
                </div>
            </div>
        </div>
    </div>
</div>